import React from 'react';
import Icon from '../../../components/AppIcon';

const OfflineIndicator = ({ isOffline, pendingSyncs = 0 }) => {
  if (!isOffline && pendingSyncs === 0) return null;

  return (
    <div className={`fixed top-16 left-0 right-0 z-50 transition-all duration-300 ${
      isOffline ? 'translate-y-0' : '-translate-y-full'
    }`}>
      <div className="bg-warning text-warning-foreground px-4 py-2 text-center text-sm font-medium">
        <div className="flex items-center justify-center space-x-2">
          <Icon name="WifiOff" size={16} />
          <span>Offline - Daten werden synchronisiert, sobald die Verbindung wiederhergestellt ist</span>
        </div>
      </div>
    </div>
  );
};

export default OfflineIndicator;
